import { ArrowUpRight } from "@phosphor-icons/react";
import { SiteBrand } from "./SiteBrand";

const DATA = [["C.F. / P.IVA", "03054440189"], ["REA", "PV - 343497"], ["Codice SDI", "M5UXCR1"], ["PEC", "diotech.srls@pec.it"]];

const Contact = ({ title, name, phone, tel, email }) => (
  <div className="mb-6">
    <div className="text-[11px] tracking-[.16em] text-[#747674] uppercase mb-2">{title}</div>
    <a href={`tel:${tel}`} className="block dt-footer-link"><span className="text-xs mr-2">{name}</span><strong className="text-[#f8f8f4] font-medium">{phone}</strong></a>
    <a href={`mailto:${email}`} className="block text-sm dt-footer-link mt-1">{email}</a>
  </div>
);

export const SiteFooter = () => (
  <footer className="bg-[#111213] border-t border-white/10 pt-16 pb-6" data-testid="public-footer-info">
    <div className="dt-container">
      <div className="grid gap-12 md:grid-cols-3">
        <div>
          <SiteBrand testId="footer-brand" />
          <p className="mt-5 text-sm text-[#8a9393] leading-relaxed">Persone, tecnologia e continuità.<br />Al fianco della tua azienda.</p>
          <p className="mt-5 text-sm font-semibold text-[#f8f8f4]">DIOTECH S.r.l.s.</p>
          <p className="text-sm text-[#b1b8b5]">Via Matteotti 61 · 27029 Vigevano (PV)</p>
          <dl className="mt-4 grid grid-cols-2 gap-x-4 gap-y-2 text-xs">
            {DATA.map(([k, v]) => (
              <div key={k}><dt className="text-[#747674]">{k}</dt><dd className="text-[#c9cbcc] break-all">{v}</dd></div>
            ))}
          </dl>
        </div>
        <div>
          <h2 className="dt-display text-2xl mb-6">Contatti</h2>
          <Contact title="Assistenza" name="Simone" phone="320 961 3945" tel="+393209613945" email="assistenza@diotech.it" />
          <Contact title="Commerciale" name="Alessandro" phone="375 995 0836" tel="+393759950836" email="commerciale@diotech.it" />
        </div>
        <div className="rounded-lg border border-white/10 bg-[#181a1c] p-6 h-fit">
          <div className="dt-eyebrow mb-4"><span className="dt-square" /> Il supporto, a portata di clic</div>
          <h2 className="dt-display text-2xl">Software assistenza remota</h2>
          <p className="text-sm text-[#aaacae] mt-3 leading-relaxed">Sei al telefono con un nostro tecnico? Apri il collegamento per ricevere supporto sul tuo dispositivo.</p>
          <a href="https://custom.teamviewer.com/6rkg6jp" target="_blank" rel="noopener noreferrer" className="dt-btn mt-5 w-full justify-between" data-testid="footer-remote-btn">
            Avvia assistenza remota <ArrowUpRight size={18} weight="bold" />
          </a>
        </div>
      </div>
      <div className="mt-14 pt-6 border-t border-white/10 flex flex-col sm:flex-row gap-3 justify-between text-xs text-[#8a9393]">
        <p>© {new Date().getFullYear()} DIOTECH S.r.l.s. · Tutti i diritti riservati.</p>
        <nav className="flex flex-wrap gap-5">
          <a href="https://www.diotech.it/" className="dt-footer-link">www.diotech.it</a>
          <a href="https://www.iubenda.com/app/privacy-policy/84381185" target="_blank" rel="noopener noreferrer" className="dt-footer-link">Privacy</a>
          <a href="https://www.iubenda.com/privacy-policy/84381185/cookie-policy" target="_blank" rel="noopener noreferrer" className="dt-footer-link">Cookie</a>
        </nav>
      </div>
    </div>
  </footer>
);
